import React, { useEffect, useState } from 'react';
import LangA from '../../../i18n/LangA';
import cx from 'classnames';
import { useI18nInitNamespace } from '../../../i18n/useI18nInitNamespace';
import { t } from '../../../i18n/i18n';
import headerTranslations from '../../../i18n/translations/components/header/header.json';
const HeaderE = ({ handleAction, registerUrlDestination, isAuthenticated }) => {
  useI18nInitNamespace('header', headerTranslations, true);

  const [isMobile, setIsMobile] = useState(false);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth <= 1024);
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <LangA
      id="navigation_register_dashboard_button"
      rel="nofollow"
      className={isMobile ? 'btn btn--primary is-small text-bold' : 'btn btn--primary is-small'}
      style={{ background: '#f4a41a' }}
      onClick={(e) => handleAction(e, '', true, ({ param }) => (window.location.href = registerUrlDestination + param))}
      customAB={true}
    >
      {!isAuthenticated ? t('a_Sign_Up_Free') : t('a_Dashboard')}
    </LangA>
  );
};

HeaderE.displayName = 'HeaderE';
export default HeaderE;
